import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { ShippingChangeApi, ShippingDriverNoticeApi, ShippingHistoryApi } from '../models';
import { API_BUSINESS_URL } from '@/utils';

const shippingHistoryService = createApi({
  reducerPath: 'shippingHistoryService',
  baseQuery: createBaseQueryWithReauth(`${API_BUSINESS_URL}`),
  tagTypes: ['ShippingHistory'],
  endpoints: (builder) => ({
    getShippingHistory: builder.query<ShippingHistoryApi[], { number: string }>({
      query: ({ number }) => ({
        url: `/shipping-history/${number}`,
      }),
      providesTags: ['ShippingHistory'],
    }),
    getShippingChanges: builder.query<ShippingChangeApi[], { number: string }>({
      query: ({ number }) => ({
        url: `/shipping-history/${number}/changes`,
      }),
      providesTags: ['ShippingHistory'],
    }),
    getShippingDriverNotices: builder.query<ShippingDriverNoticeApi[], { number: string }>({
      query: ({ number }) => ({
        url: `/shipping-history/${number}/driver-notices`,
      }),
      providesTags: ['ShippingHistory'],
    }),
  }),
});

export default shippingHistoryService;

export const {
  useGetShippingHistoryQuery,
  useGetShippingChangesQuery,
  useGetShippingDriverNoticesQuery,
} = shippingHistoryService;
